import {APIClient} from "../base";
import {PaginationInterface} from "../../../interfaces/PaginationInterface";

const CustomerApi = {
    getAll: async (paging: PaginationInterface) => await APIClient.get('/customer', paging),
    getDetail: async (id: number|string|any) => await APIClient.get('/customer/' + id, {}),
}

export default CustomerApi;